import { Component } from '@angular/core';

@Component({
    selector: 'app-footer-privacy-policy-popup',
    templateUrl: './footer-privacy-policy-popup.component.html',
    styleUrls: ['./footer-privacy-policy-popup.component.scss'],
    standalone: false
})
export class FooterPrivacyPolicyPopupComponent {

}
